import { render, staticRenderFns } from "./CommonFormItem.vue?vue&type=template&id=f7bf0c28&scoped=true&"
import script from "./CommonFormItem.vue?vue&type=script&lang=js&"
export * from "./CommonFormItem.vue?vue&type=script&lang=js&"
import style0 from "./CommonFormItem.vue?vue&type=style&index=0&id=f7bf0c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bf0c28",
  null
  
)

export default component.exports